export default "__VITE_ASSET__el69XI_P__"